var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_4733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6899 13.6578C118.228 31.8683 113.449 23.5807 113.449 60.0016C113.449 96.4225 118.236 88.1349 86.6899 106.345C55.1515 124.556 64.7189 124.556 33.1726 106.345C1.63415 88.1349 6.41388 96.4225 6.41388 60.0016C6.41388 23.5807 1.62625 31.8683 33.1726 13.6578C64.711 -4.55261 55.1436 -4.55261 86.6899 13.6578Z",
    fill: "url(#paint0_linear_965_4733)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.457 29.3088C114.76 34.0886 113.448 40.8908 113.448 59.994C113.448 96.4148 118.236 88.1273 86.6896 106.338C68.8663 116.632 64.1655 121.104 57.7583 119.761C54.4559 114.981 55.7674 108.179 55.7674 89.0754C55.7674 52.6545 50.9798 60.942 82.5261 42.7316C100.357 32.4374 105.05 27.9658 111.457 29.3088Z",
    fill: "url(#paint1_linear_965_4733)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25049 29.0091C4.94812 33.7889 6.25959 40.5911 6.25959 59.6943C6.25959 96.1151 1.47195 87.8276 33.0183 106.038C46.5596 113.852 52.5244 118.315 57.4147 119.421C54.3493 114.657 55.6134 107.752 55.6134 89.0127C55.6134 66.4096 53.7726 61.0294 59.9191 55.8389C56.2218 52.5839 49.4511 49.5107 37.1818 42.424C19.3506 32.1298 14.6577 27.6581 8.25049 29.0012",
    fill: "#055B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.642 26.4488L59.9784 49.3599L18.841 26.4646L59.5043 3.55338L100.642 26.4488ZM105.919 26.4488L59.4727 0.598633L13.5635 26.4725L60.01 52.3226L105.919 26.4488ZM77.4462 16.4784C87.3217 21.9771 87.4165 30.9283 77.6516 36.427C67.8867 41.9256 51.9041 41.9335 42.0286 36.4349C32.1531 30.9362 32.0583 21.985 41.8232 16.4863C51.5881 10.9877 67.5707 10.9798 77.4462 16.4784ZM80.0691 15.0011C68.7083 8.68074 50.3952 8.68074 39.1687 15.009C27.9422 21.3372 28.0449 31.5919 39.4057 37.9122C50.7665 44.2326 69.0796 44.2326 80.3061 37.9043C91.5326 31.5761 91.4299 21.3214 80.0691 15.0011ZM74.997 34.9575C83.332 30.2646 83.253 22.6566 74.8232 17.9637C66.3935 13.2709 52.8048 13.2788 44.4778 17.9637C36.1428 22.6566 36.2218 30.2646 44.6516 34.9575C53.0813 39.6503 66.67 39.6424 74.997 34.9575Z",
    fill: "#0C9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3523 53.0537C75.1731 58.967 65.9501 74.5301 66.1577 87.3821C66.3654 100.234 75.8507 105.171 86.9205 98.7013C97.7007 92.4008 106.257 77.3504 106.153 65.1148C106.05 52.8192 97.2363 47.2987 86.3523 53.0537ZM84.347 87.7149L75.3207 82.6745L78.6536 76.9685L84.4016 80.2415L95.4114 62.4473L98.5312 64.6784L84.347 87.7149Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_4733",
    x1: 60.1557,
    y1: 54.0014,
    x2: 78.5504,
    y2: 5.1766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123968,
    stopColor: "#066F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A9372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_965_4733",
    x1: 63.1552,
    y1: 58.0017,
    x2: 98.1562,
    y2: 101.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A9372"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_4733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3);
export default __webpack_public_path__ + "static/media/home3.a534da96.svg";
export { ForwardRef as ReactComponent };